import InputAdornment from '@mui/material/InputAdornment';
import { useEffect, useState } from 'react';
import { Controller } from "react-hook-form"

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const MpgAutocompleteMulti = ({ rhfFormInstance, label, name, type, sx, disabled, required, onChangeExtraHandler, optionList, startAdornmentComp, placeholder, defaultValue, disabledOptionIdArray }) => {
    const myStyle = {
        '& .MuiInputBase-root.Mui-disabled': {
            backgroundColor: '#f5f5f5',
        },
    }
    const { control } = rhfFormInstance

    return (
        <Controller
            control={control}
            name={name}
            defaultValue={defaultValue || []}
            render={({
                field: { onChange, onBlur, value, name, ref, ...field },
                fieldState: { invalid, isTouched, isDirty, error },
                formState: { errors },
            }) => {
                // console.log("val-multi", value)
                return (
                    <Autocomplete
                        multiple
                        disablePortal
                        fullWidth
                        disabled={!!disabled}
                        id={`${name}-mpg-autocomplete-multi`}
                        value={value || []} /**IMP to pass [] */
                        defaultValue={defaultValue || []}
                        options={optionList}
                        disableCloseOnSelect

                        getOptionLabel={(option) => option.selectOptionLabel}

                        onChange={(e, values, reason, details) => {
                            onChange(values)

                            if (!!onChangeExtraHandler) {
                                /**passing both all args from onchange event*/
                                onChangeExtraHandler(e, values, reason, details)
                            }
                        }}

                        isOptionEqualToValue={(option, value) => {
                            return option.selectOptionValue === value.selectOptionValue
                        }}

                        /**to disable options */
                        getOptionDisabled={(option) => {
                            /**by this, we can add "selectOptionDisabled" true during creating autocomplete list*/
                            if (!!option?.selectOptionDisabled) {
                                return true
                            }

                            /**by this we can pass array of unique ids to be diabaled */
                            if (!!disabledOptionIdArray) {
                                return !!disabledOptionIdArray.includes(option.id)
                            }
                        }}

                        renderOption={(props, option, { selected }) => (
                            <li {...props} key={option.id}>
                                <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                />
                                {option.selectOptionLabel}
                            </li>
                        )}
                        sx={[myStyle, sx]}

                        ListboxProps={{ style: { maxHeight: '200px' } }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                {...field}
                                inputRef={ref}
                                margin='normal'
                                label={label}
                                placeholder={placeholder}
                                size='large'
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                required={!!required}
                                error={!!error}
                                helperText={error && error.message}
                            />
                        )}
                    />
                )
            }}
        />

    )
}
export default MpgAutocompleteMulti